import { render, staticRenderFns } from "./tempFooter.vue?vue&type=template&id=b761f450&scoped=true"
import script from "./tempFooter.vue?vue&type=script&lang=js"
export * from "./tempFooter.vue?vue&type=script&lang=js"
import style0 from "./tempFooter.vue?vue&type=style&index=0&id=b761f450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b761f450",
  null
  
)

export default component.exports